import React from "react";
import { MdHelpCenter, MdOutlineNavigateBefore } from "react-icons/md";
import PageTitle from "../../components/PageTitle/PageTitle";
import TwoSidebars from "../../layouts/TwoSidebars/TwoSidebars";
import ButtonGroup from "../../components/ButtonGroup/ButtonGroup";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { BUTTON_STYLES, ICON_SIZES } from "../../helpers/constants";
import SettingsBlocks from "../../components/SettingsBlocks/SettingsBlocks";
import useMobile from "../../hooks/useMobile";
import useGeneralOptionsDropdownMenu from "../../hooks/useGeneralOptionsDropdownMenu";
import TextList, {
  ELinkType,
  ITextListItem,
} from "src/components/TextList/TextList";
import { AnimatePresence } from "framer-motion";

const HELP_LINKS: ITextListItem[] = [
  {
    text: "eXpenser.net sitio corporativo",
    link: {
      type: ELinkType.EXTERNAL,
      to: "https://expenser.net",
    },
  },
  {
    text: "Tutoriales",
    link: {
      type: ELinkType.INTERNAL,
      to: "/settings",
    },
  },
  {
    text: "Documentación",
    link: {
      type: ELinkType.INTERNAL,
      to: "/settings",
    },
  },
  {
    text: "FAQ: Preguntas Frecuentes",
    link: {
      type: ELinkType.INTERNAL,
      to: "/settings",
    },
  },
  {
    text: "Política de Privacidad",
    link: {
      type: ELinkType.INTERNAL,
      to: "/privacy-policy",
    },
  },
  {
    text: "Términos y Condiciones",
    link: {
      type: ELinkType.INTERNAL,
      to: "/settings",
    },
  },
];

const HelpCenterPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobile } = useMobile();
  const generalOptionsDropdown = useGeneralOptionsDropdownMenu();

  return (
    <TwoSidebars
      right={
        isMobile ? null : (
          <SettingsBlocks layout="vertical" columns={isMobile ? 2 : 1} />
        )
      }
    >
      <div
        className={clsx([
          "flex",
          "flex-col",
          "w-full",
          "gap-2",
          "md:gap-2",
          "h-full",
        ])}
      >
        <AnimatePresence>
          <>
            <PageTitle
              titleLink="/settings"
              icon={<MdHelpCenter size={ICON_SIZES.MD} />}
              title={t("Ayuda")}
              subtitle={t("Centro de ayuda")}
              isLoading={false}
              rightSide={
                <>
                  <ButtonGroup
                    align="right"
                    gap={1}
                    buttons={[
                      {
                        icon: <MdOutlineNavigateBefore size={ICON_SIZES.SM} />,
                        className: isMobile ? BUTTON_STYLES.HEADING : "",
                        tooltip: "Atras",
                        onClick: () => {
                          navigate("/settings");
                        },
                      },
                      generalOptionsDropdown,
                    ]}
                  />
                </>
              }
            />

            <TextList items={HELP_LINKS}>
              <TextList.Top>
                <div className="text-sm md:text-base">
                  Utiliza los siguientes enlaces para obtener ayuda.
                </div>
              </TextList.Top>
            </TextList>
          </>
        </AnimatePresence>
      </div>
    </TwoSidebars>
  );
};

export default HelpCenterPage;
